export default "__VITE_ASSET__BGZ4$WB5__"